import { Component, OnInit } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constructor(private oauthService: OAuthService) {}

  ngOnInit(): void {}

  public async login(): Promise<void> {
    this.oauthService.logOut();

    if (!this.oauthService.loginUrl) {
      await this.oauthService.loadDiscoveryDocument();
    }

    this.oauthService.initLoginFlow();
  }
}
